import React, { Children } from 'react';
import { motion } from 'framer-motion';
const categories = [{
  id: 'main-dishes',
  name: 'Main Dishes',
  count: '17 Items',
  emoji: '🥘',
  color: 'bg-orange-100'
}, {
  id: 'snacks',
  name: 'Sides & Extras',
  count: '10 Items',
  emoji: '🥥',
  color: 'bg-amber-100'
}, {
  id: 'drinks',
  name: 'Drinks & Beverages',
  count: '8 Items',
  emoji: '🥤',
  color: 'bg-blue-100'
}, {
  id: 'catering',
  name: 'Catering & Events',
  count: 'Book Now',
  emoji: '🎉',
  color: 'bg-red-100'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 24
    }
  }
};
interface MenuCategoriesProps {
  onNavigate?: (page: string) => void;
}
export function MenuCategories({
  onNavigate
}: MenuCategoriesProps) {
  return <section id="menu" className="py-16 bg-light" data-id="element-142">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="font-heading text-4xl md:text-5xl text-charcoal uppercase tracking-wide mb-4" data-id="element-145">
            Explore Our Menu
          </h2>
          <div className="w-24 h-1 bg-amber mx-auto rounded-full" data-id="element-146" />
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-147">
          {categories.map(cat => <motion.button key={cat.id} onClick={() => onNavigate?.(cat.id)} variants={itemVariants} whileHover={{
          y: -5,
          scale: 1.02
        }} className="w-full text-left group relative bg-cream rounded-3xl p-8 flex flex-col items-center text-center overflow-hidden border border-amber/10 shadow-sm hover:shadow-xl hover:shadow-amber/20 transition-all duration-300 cursor-pointer" data-id="element-148">
              <div className="absolute -right-12 -top-12 w-40 h-40 bg-amber/5 rounded-full group-hover:scale-150 transition-transform duration-500 ease-out" data-id="element-149" />

              <div className={`w-24 h-24 rounded-2xl ${cat.color} flex items-center justify-center text-5xl shadow-inner relative z-10 group-hover:rotate-12 transition-transform duration-300 mb-6`} data-id="element-150">
                {cat.emoji}
              </div>

              <div className="relative z-10" data-id="element-151">
                <h3 className="font-heading text-2xl text-charcoal uppercase group-hover:text-victory-red transition-colors mb-2" data-id="element-152">
                  {cat.name}
                </h3>
                <p className="font-body text-charcoal/60 font-medium text-lg" data-id="element-153">
                  {cat.count}
                </p>
              </div>
            </motion.button>)}
        </motion.div>
      </div>
    </section>;
}